import { render, staticRenderFns } from "./agv-color-filter.vue?vue&type=template&id=2eece556&scoped=true&lang=pug&"
import script from "./agv-color-filter.vue?vue&type=script&lang=js&"
export * from "./agv-color-filter.vue?vue&type=script&lang=js&"
import style0 from "./agv-color-filter.vue?vue&type=style&index=0&id=2eece556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eece556",
  null
  
)

export default component.exports